import { Box, Typography, TypographyProps } from '@mui/material';
import moment from 'moment-timezone';
import React, { ReactNode } from 'react';

import { ContextActionContainer } from 'shared/components/internal/ContextAction';
import { RecordType } from 'shared/components/internal/Records';

interface RecordAttributeProps {
  children?: ReactNode;
  className?: any;
  ContentTextProps?: TypographyProps;
  label?: ReactNode;
  record?: RecordType;
  subLabel?: ReactNode;
  SubLabelTextProps?: TypographyProps;
}

export const RecordAttribute = ({
  children,
  className,
  ContentTextProps = {},
  label,
  record,
  subLabel,
  SubLabelTextProps = {},
}: RecordAttributeProps) => {
  const eventTimestamp = record?.timestamp
    ? moment.unix(record.timestamp / 1000).toDate()
    : undefined;

  /* TODO: recreate grid/flexbox and add dl/dt/dd tags instead of div. */
  return (
    <Box className={className}>
      {/* Although this should be a dt tag, the Chips don't seem to render
        a label. This would mean that a dd tag gets rendered without a dt, so
        we'd have to think of a way to handle this case. */}
      {!!label && (
        <Typography
          color='text.secondary'
          component='div'
          fontSize='1rem'
          fontWeight='bold'
        >
          {label}
        </Typography>
      )}
      {/* This would be a dd tag. */}
      <Box>
        <Typography
          component='div'
          fontSize='1.125rem'
          marginTop='2px'
          sx={{ wordBreak: 'break-word' }}
          {...ContentTextProps}
        >
          <ContextActionContainer
            contextData={record}
            eventTimestamp={eventTimestamp}
          >
            {children}
          </ContextActionContainer>
        </Typography>
        {subLabel !== undefined && (
          <Typography
            color='text.secondary'
            component='div'
            fontSize='1rem'
            marginTop='2px'
            sx={{ wordBreak: 'break-word' }}
            {...SubLabelTextProps}
          >
            <ContextActionContainer
              contextData={record}
              eventTimestamp={eventTimestamp}
            >
              {subLabel}
            </ContextActionContainer>
          </Typography>
        )}
      </Box>
    </Box>
  );
};
